import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {GetResponse, PostResponse} from '@app/shared';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private currencyUrl = environment.financeApiBaseUrl + '/api/currency';
  private currencyExchangeUrl =
    environment.financeApiBaseUrl + '/api/currencyExchange';

  constructor(private http: HttpClient) {}

  getCurrency(params: any, accessToken?: string): Observable<any> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return this.http
      .get<GetResponse>(this.currencyUrl, { params, headers: headers })
  }

  createCurrency(data: any): Observable<any> {
    return this.http
      .post<PostResponse>(this.currencyUrl + '/form', data)
  }

  updateCurrency(data: any): Observable<any> {
    return this.http
      .put<PostResponse>(this.currencyUrl + '/form', data)
  }

  patchCurrency(data: any): Observable<any> {
    return this.http
      .patch<PostResponse>(this.currencyUrl + '/form', data)
  }

  deleteCurrency(ids: number[]): Observable<any> {
    return this.http
      .delete<PostResponse>(`${this.currencyUrl}`, { params: { ids: ids } })
  }

  // Add methods for CurrencyExchange
  getCurrencyExchange(params: any): Observable<any> {
    return this.http
      .get(`${this.currencyExchangeUrl}`, { params })
      .pipe(finalize(() => console.log('getCurrencyExchange completed')));
  }

  createCurrencyExchange(data: any): Observable<any> {
    return this.http
      .post(`${this.currencyExchangeUrl}`, data)
      .pipe(finalize(() => console.log('createCurrencyExchange completed')));
  }

  updateCurrencyExchange(data: any): Observable<any> {
    return this.http
      .put(`${this.currencyExchangeUrl}`, data)
      .pipe(finalize(() => console.log('updateCurrencyExchange completed')));
  }

  deleteCurrencyExchange(ids: number[]): Observable<any> {
    return this.http
      .delete(`${this.currencyExchangeUrl}`, { params: { ids: ids } })
      .pipe(finalize(() => console.log('deleteCurrencyExchange completed')));
  }

  convertCurrency(amount: number, fromCurrencyId: number, toCurrencyId: number, date: string): Observable<any> {
    const payload = {
      amount,
      fromCurrencyId,
      toCurrencyId,
      date
    };
    
    return this.http.post(`${this.currencyUrl}/convert`, payload);
  }
}
